<template>
    <div>
        <div class="custom-search">
            <b-row>
                <b-col  class="col-md-2 mb-1">
                    <label for="start-date-input">{{ $t('accountingTransactionOutputVatControlReport.start_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="startDate" @input="getAccountingTransactionOutputVatControlReportList()"></CustomDatePicker>
                </b-col>
                <b-col  class="col-md-2 mb-1">
                    <label for="end-date-input">{{ $t('accountingTransactionOutputVatControlReport.end_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="endDate" @input="getAccountingTransactionOutputVatControlReportList()"></CustomDatePicker>
                </b-col>
                <b-col  class="col-md-4 mb-1">
                    <br>
                    <b-row>
                        <b-col>
                            <b-form-radio v-model="radioSource" name="some-radios" value="1" @checked="getAccountingTransactionOutputVatControlReportList">
                                {{ $t('accountingTransactionOutputVatControlReport.vat_accounting') }}
                            </b-form-radio>
                        </b-col>
                        <b-col>
                            <b-form-radio v-model="radioSource" name="some-radios" value="2" @checked="getAccountingTransactionOutputVatControlReportList">
                                {{ $t('accountingTransactionOutputVatControlReport.gib_invoice') }}
                            </b-form-radio>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="col-md-4 custom-search d-flex justify-content-end">
                    <div class="d-flex align-items-center">
                        <b-button class="d-inline-block mr-05" size="sm" variant="outline-primary" @click="getAccountingTransactionOutputVatControlReportList()">{{ $t('accountingTransactionOutputVatControlReport.list') }}</b-button>
                        <b-button style="float:right;" class="ml-1" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button></div>
                </b-col>
            </b-row>
        </div>
        <!-- table -->
        <vue-good-table ref="accountingTransactionOutputVatControlReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                      enabled: false,
                      externalQuery: searchTerm }" :select-options="{
                      enabled: false,
                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                      selectionInfoClass: 'custom-class',
                      selectionText: 'rows selected',
                      clearSelectionText: 'clear',
                      disableSelectInfo: true, // disable the select info panel on top
                      selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                    }" :pagination-options="{
                      enabled: true,
                      perPage:pageLength
                    }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
        </vue-good-table>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                total: 0,
                pageLength: 10,
                searchTerm: '',
                dir: false,
                pageNo: 1,
                radioSource:1,
                name: '',
                startDate: null,
                endDate: null,
                rows: [],
                columns: [
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.invoice_no'),
                        field: `invoiceNo`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.invoice_date'),
                        field: `invoiceDate`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.currency'),
                        field: `currency`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.currency_value'),
                        field: `currencyValue`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.taxable_amount'),
                        field: `taxableAmount`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.amount_excluding_vat'),
                        field: `amountExcludingVAT`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.vat_amount'),
                        field: `vatAmount`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.taxable_amount_tl'),
                        field: `taxableAmountTL`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.amount_excluding_vat_tl'),
                        field: `amountExcludingVATTL`,
                    },
                    {
                        label: this.$t('accountingTransactionOutputVatControlReport.vat_amount_tl'),
                        field: `vatAmountTL`,
                    }
                ],
                accountingId : 0,
            }   
        },
        props: {
            subsidiaryLedgerId: {
                type: Number
            }
        },
        mounted() {
            this.startDate = new Date().toJSON()
            this.endDate = new Date().toJSON()
        },
        methods: {
            getAccountingTransactionOutputVatControlReportList() {
                this.rows = []
                const controller = {
                    name: 'AccountingTransaction',
                    actionName :'AccountingTransactionOutputVatControlReport'
                }
                const data = {
                    pageLength: this.pageLength,
                    pageNo: this.pageNo,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    subsidiaryLedgerId: this.subsidiaryLedgerId,
                    sourceType: this.radioSource
                }
                const payload = {
                    data: data,
                    controller: controller
                }

                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.rows = response.data.accountingTransactionOutputVatControlReportList
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            exportExcel() {
                const controller = {
                    name: 'AccountingTransaction',
                    actionName: 'CanExport'
                }
                const data = {
                    columnList: this.columns,
                    dataList: this.rows,
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("Gelir KDV Kontrol Raporu", response.data.base64, 'xlsx')
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },            
        },
    }
    </script>
    
    <style lang="scss">
    .excel-css {
        float: right;
        margin-right: 1em;
        width: 9.5em;
        color: #7367f0;
        border: 1px solid #7367f0;
        background-color: transparent;
        margin-left: 1em;
        height: 2em;
        border-radius: 0.358rem;
    }
    
    .tableSize {
        font-size: 13px !important;
        border-collapse: collapse;
        width: 100%;
        max-width: 100%;
        table-layout: auto;
    }
    </style>
    